import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DictionaryItemUI } from 'src/app/domains/internal-facilities/ai-assistant/models/ai-assistant.model';
import { AiAssistantService } from 'src/app/domains/internal-facilities/ai-assistant/services/ai-assistant.service';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { DictionaryItem } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-ai-assistant-table',
  templateUrl: './ai-assistant-table.component.html',
  styleUrls: ['./ai-assistant-table.component.scss']
})
export class AiAssistantTableComponent implements OnInit {
  // I/O
  @Input() dictionary: DictionaryItem[];
  public _loading: boolean;
  @Input() set loading(value: boolean) {
    this._loading = value;
  };
  @Output() onUpdatingDictionary: EventEmitter<DictionaryItem> = new EventEmitter();
  @Output() onDeletingDictionary: EventEmitter<any> = new EventEmitter();

  constructor(
    private aiAssistantService: AiAssistantService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void { }

  public updatingDictionary(d: DictionaryItem): void {
    this.onUpdatingDictionary.emit(d);
  }

  public deleteDictionary(d: DictionaryItemUI, index: number): void {
    d._isUpdating = true;
    this.notification.showConfirmation('internal-facilities.ai-assistant.table.confirmation-delete').then((result: string) => {
      if(result === 'ok') {
        this.aiAssistantService.deleteDictionary(d).subscribe(() => {
          if(index !== -1) {
            this.dictionary.splice(index, 1);
          }
          this.onDeletingDictionary.emit();
          d._isUpdating = false;
        })
      }
      else {
        d._isUpdating = false;
      }
    })
  }
}
